import i18next from 'i18next';
import * as yup from 'yup';

export const schema = yup.object().shape({
  uuid: yup.string(),
  comment: yup.string().nullable(),
  hoursRaw: yup.string().required(i18next.t('validation.additionalTeachingLoads.hoursRequired')),
  teacherUuid: yup
    .string()
    .test('empty-uuid', i18next.t('validation.additionalTeachingLoads.teacherRequired'), (uuid) => {
      return !!uuid?.length;
    })
    .required(i18next.t('validation.additionalTeachingLoads.teacherRequired')),
  subjectUuid: yup.string().nullable(),
  classUuid: yup.string().nullable(),
});
